import springApi from '../../services/springApi'

export const getQuestions = params => (
	new Promise((resolve, reject) => {
		springApi()
			.get('/questions', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const storeQuestion = data => (
	new Promise((resolve, reject) => {
		springApi()
			.post('/questions', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const updateQuestion = (id, data) => (
	new Promise((resolve, reject) => {
		springApi()
			.put(`/questions/${id}`, data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const deleteQuestion = id => (
	new Promise((resolve, reject) => {
		springApi()
			.delete(`/questions/${id}`)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)